module.exports = __webpack_public_path__ + "static/img/logo.a7d4fd68.png";